// import packages
import gql from "graphql-tag"

// export gqls
export const GET_DEVICES = gql`
  query Devices($take: Int, $skip: Int) {
    devices(take: $take, skip: $skip) {
      total
      data {
        id
        number
        name
        englishName
        type
        description
        url
        photoUrl
      }
    }
  }
`
export const SUM_DEVICES = gql`
  query Devices {
    devices(take: 0) {
      total
    }
  }
`

export const GET_DEVICE = gql`
  query Device($id: ID!) {
    device(id: $id) {
      id
      number
      name
      englishName
      type
      description
      url
      photoUrl
    }
  }
`

export const UPDATE_DEVICE = gql`
  mutation UpdateDevice($id: ID!, $input: DeviceUpdateInput!) {
    updateDevice(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_DEVICE = gql`
  mutation CreateDevice($input: DeviceCreateInput!) {
    createDevice(input: $input) {
      id
    }
  }
`

export const DELETE_DEVICE = gql`
  mutation DeleteDevice($id: ID!) {
    deleteDevice(id: $id)
  }
`
